import React, { useEffect, useState } from "react";
import "./ScrollToTop.css";
import { Spinner } from "reactstrap";

export default function ScrollToTop({
  spinnerLoadingToggle
}) {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    var car = document.getElementById("car");
    if (window.pageYOffset > 300) {
      setIsVisible(true);
      car.classList.add("show");
    } else {
      setIsVisible(false);
      car.classList.remove("show");
      car.style.transition = "all 0.2s";
    }
  };

  /*TOP TO BOTTOM ARROW :: START*/

  var scrollTopBtn = document.getElementById("go_bottom");
  window.onscroll = function () {
    scrollfunction()
  };
  function scrollfunction() {
    if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
      scrollTopBtn && (scrollTopBtn.style.display = "block");
    } else if (scrollTopBtn) {
      scrollTopBtn.style.display = "none";
    }
    if (((window.scrollY + window.innerHeight) > (document.body.scrollHeight - 50)) && scrollTopBtn) {
      scrollTopBtn.style.display = "none";
    }
  }
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function (e) {
      window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
    });
  }

  /*TOP TO BOTTOM ARROW :: END*/

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    var car = document.getElementById("car");
    car.classList.add("car_top");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // var source = "https://cdn.videvo.net/videvo_files/audio/premium/audio0006/watermarked/33PontiacHornBlow3%20PE735805_preview.mp3"
    // var audio = document.createElement("audio");

    // audio.autoplay = true;
    // //
    // audio.load();
    // audio.src = source;
    // audio.play();

    setTimeout(() => {
      car.style.transition = "0s";
      car.classList.remove("car_top");
    }, 1000);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    // returned function will be called on component unmount
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <>
      <div className="scroll-to-top">
        <div id="car" onClick={scrollToTop}>
          <span>
            <img
              src={require("../../assets/car_logo.png")}
              alt="Top"
              title="Back to top"
            />
          </span>
        </div>
      </div>
      {/* <!---- Top to Bottom Arrow----> */}
      <div>
        <button id="go_bottom" onClick="buttonClickedfunction()">
        {spinnerLoadingToggle ? (
            <Spinner style={{ height: '1rem', width: '1rem' }} size="sm" color="light" />
        ) : <i className="fa fa-angle-double-down" aria-hidden="true"></i>}
        </button>
      </div>
      {/* <!---- Top to Bottom Arrow----> */}
    </>
  );
}
